"use strict";
/*
 *  MetricsService is a barebones class to calculate simple metrics ( from insights )
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.metricsService = void 0;
exports.metricsService = {
    sum: (values) => {
        let sum = 0;
        for (let i = 0; i < values.length; ++i) {
            sum += values[i];
        }
        return sum;
    },
    average: (values) => {
        return exports.metricsService.sum(values) / values.length;
    },
    percentageChange: (originalValue, newValue) => {
        if (newValue === originalValue) {
            return 0;
        }
        const absolutePercentageChange = Math.abs(newValue - originalValue) / Math.abs(originalValue);
        return newValue < originalValue
            ? -1 * absolutePercentageChange
            : absolutePercentageChange;
    },
    standardDeviation: (values) => {
        if (values.length === 0) {
            return 0;
        }
        const average = exports.metricsService.average(values);
        let sumVar = 0;
        for (let i = 0; i < values.length; ++i) {
            const diff = values[i] - average;
            sumVar += diff * diff;
        }
        return Math.sqrt(sumVar / values.length);
    },
};
